<template>
  <label class="checkbox__label filter-available">
    <input
      class="checkbox__input"
      type="checkbox"
      :checked="availableOnly"
      @change="handleChange"
    />

    <svg
      class="checkbox__icon"
      :class="availableOnly ? 'icon-checkbox_checked' : 'icon-checkbox'"
      width="16"
      height="16"
    >
      <use
        v-bind:xlink:href="availableOnly ? '#checkbox-checked' : '#checkbox'"
      />
    </svg>

    <span class="checkbox__text">
      {{ title }}
    </span>
  </label>
</template>

<script>
export default {
  props: {
    availableOnly: {
      required: true
    },
    title: {
      type: String,
      default: () => ''
    }
  },

  methods: {
    handleChange(ev) {
      this.$emit('availability-change', event.target.checked ? '1' : '');
    }
  }
};
</script>
